import { render } from "./MiniLoader.vue?vue&type=template&id=4c6bebbc"
import script from "./MiniLoader.vue?vue&type=script&lang=js"
export * from "./MiniLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__